import api from "../api/axios";


export const obtenerDocumentos = () => {
    return api.get("/documentos");
};


export const crearDocumento = (formData) => {
    return api.post(
        "/crear/documentos",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};


export const eliminarDocumento = (id) => {
    return api.delete(
        `/delete/documentos/${id}`
    );
};



export const descargarDocumento = (id) => {
    return api.get(
        `/documentos/download/${id}`,
        {
            responseType: "blob",
        }
    );
};

export const obtenerDocumentosPublicos = () => {
    return api.get("/documentos/public");
};